module.exports = __webpack_public_path__ + "static/media/back.a1339c0f.svg";